import React, { SetStateAction, useEffect, useState } from "react";

//Icons
import PendingActionsIcon from "@mui/icons-material/PendingActions";

import { AxiosResponse } from "axios";
import { useUser } from "../../Contexts/UserContext/UserContext";
import { IBillListDTO } from "../../Interfaces/Bill";

import { Paid } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useBills } from "../../Contexts/BillContext/BillProvider";
import {
  IPerson,
  useContacts,
} from "../../Contexts/ContactsContext/ContactsProvider";
import { useModals } from "../../Contexts/DialogContext/DialogProvider";
import useAuthConnection from "../../Hooks/useAuthConnection";
import {
  useCreateBillFromOfferMutation,
  useDuplicateOfferMutation,
} from "../../redux/apiSlices/Bill.slice";
import MoreOptionsButton from "../Buttons/MoreOptionsButton/MoreOptionsButton";
import { DocumentApi } from "../../redux/apiSlices/Document";

interface props {
  billDTO: IBillListDTO;
  setClickedOffer?: React.Dispatch<SetStateAction<IBillListDTO | undefined>>;
}

interface Document {
  id: number;
  title: string;
  description: string;
  fileEnding: string;
  fileId: string;
  base64: string;
  organizationId: number;
}

const OfferRow = ({ billDTO, setClickedOffer }: props) => {
  let navigate = useNavigate();
  const connection = useAuthConnection();
  const isMobile = useMediaQuery("(max-width: 1300px)");
  const dispatch = useDispatch();
  const billContext = useBills();

  const { changeVisibility } = useModals();

  const [createBillFromOffer, { isLoading }] = useCreateBillFromOfferMutation();
  const [duplicateOffer, { isLoading: isLoadingDuplicate }] =
    useDuplicateOfferMutation();
  const { enqueueSnackbar } = useSnackbar();
  const { fetchBills } = useBills();

  let { bill } = billDTO;

  useEffect(() => {
    bill = billDTO.bill;
  }, [billDTO]);

  const onPressEdit = () => {
    if (billDTO.bill.isReceipt === false) {
      navigate(`bearbeiten/${bill.billPrefix}-${bill.billNumber}`);
    } else {
      navigate(
        `/rechnungswesen/belege/bearbeiten/${bill.billPrefix}-${bill.billNumber}`,
        { replace: true }
      );
    }
  };

  const onPressDelete = () => {
    changeVisibility!("yesNoDialog", true, {
      props: {
        object: {
          submitFunction: () => {
            billContext.deleteBill!(bill);
            connection
              .delete("/bill", { data: bill })
              .then((res: AxiosResponse) => {});
          },
          modalTitle: "Rechnung löschen",
          confirmButtonText: "Löschen",
          modalText: "Möchten Sie diese Rechnung wirklich löschen?",
        },
      },
    });
    /*billContext.deleteBill!(bill);
        connection.delete("/bill", { data: bill })
            .then((res: AxiosResponse) => {
            });*/
  };

  const onPressGenerateBillFromOffer = async () => {
    enqueueSnackbar("Rechnung wird erstellt...");
    const billFromOffer = await createBillFromOffer(bill.id!).unwrap();
    console.log("billfromoffer", billFromOffer);
    dispatch({
      type: "ADD_BILL",
      payload: billFromOffer,
    });
    dispatch(DocumentApi.util.invalidateTags([{ type: "Documents" }]));
    if (fetchBills) await fetchBills();
    navigate(
      `/rechnungswesen/rechnungen/bearbeiten/${billFromOffer.bill.billPrefix}-${billFromOffer.bill.billNumber}`,
      {
        state: {
          id: `${billFromOffer.bill.billPrefix}-${billFromOffer.bill.billNumber}`,
          initialBillData: billFromOffer,
        },
      }
    );
  };

  const onPressDuplicateOffer = async () => {
    enqueueSnackbar("Angebot wird dupliziert...");
    const newOffer = await duplicateOffer(bill.id!).unwrap();
    console.log("newOffer", newOffer);
    dispatch({
      type: "ADD_BILL",
      payload: newOffer,
    });
    dispatch(DocumentApi.util.invalidateTags([{ type: "Documents" }]));
    if (fetchBills) await fetchBills();
    enqueueSnackbar("Angebot erfolgreich dupliziert", {
      variant: "success",
    });
  };

  const options = [
    {
      text: "Bearbeiten",
      function: onPressEdit,
    },
    {
      text: "Löschen",
      function: onPressDelete,
    },
    {
      text: "Rechnung generieren",
      function: onPressGenerateBillFromOffer,
    },
    {
      text: "Duplizieren",
      function: onPressDuplicateOffer,
    },
  ];

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const { persons } = useContacts();

  const getCustomerDisplayName = (bill: any) => {
    if (bill.customerName) {
      return (
        <span
          style={{
            fontSize: "1em",
            whiteSpace: "nowrap",
            overflow: "hidden",
            msTextOverflow: "ellipsis",
          }}
        >
          {bill.customerName.substring(0, 25)}
        </span>
      );
    }

    const person = persons.find((temp: IPerson) => temp.id === bill.personId);
    if (person) {
      return "Person: " + person.completeName?.substring(0, 25);
    }

    return "Kein Kunde zugewiesen";
  };

  return (
    <>
      {!isMobile && bill && (
        <div
          className="hover:bg-slate-50"
          onClick={() => {
            if (setClickedOffer) setClickedOffer(billDTO);
          }}
        >
          <div className="flex flex-row w-full items-center justify-between min-h-[50px]">
            <div className="w-[5%]">
              {!bill.isCreated && (
                <Tooltip title="Entwurf">
                  <PendingActionsIcon style={{ color: "#5e5e5eee" }} />
                </Tooltip>
              )}
              {bill.isCreated && (
                <Tooltip title="Angenommen">
                  <Paid style={{ color: "#105a37" }} />
                </Tooltip>
              )}
            </div>
            <div className="w-[15%]">
              <span>
                {bill.billPrefix}-{bill.billNumber}
              </span>
            </div>
            <div className="w-[40%]">
              <span>{getCustomerDisplayName(bill)}</span>
            </div>
            <div className="w-[20%]">
              <span>
                {new Date(bill?.date ?? "").toLocaleDateString("de-DE", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </span>
            </div>
            <div className="w-[15%]">
              <span>{bill?.netto?.toFixed(2).replace(".", ",")} €</span>
            </div>
            <MoreOptionsButton options={options} />
          </div>
        </div>
      )}

      {isMobile && bill && (
        <div
          className="flex flex-row w-full border-b-2 p-2 items-center hover:bg-slate-50"
          onClick={() => {
            if (setClickedOffer) setClickedOffer(billDTO);
          }}
        >
          <div className="flex flex-col w-[90%]">
            <div className="flex flex-row justify-between w-full">
              <span className="">Kunde:</span>
              <span className="max-w-[80%] text-ellipsis whitespace-nowrap overflow-hidden">
                {getCustomerDisplayName(bill)}
              </span>
            </div>
            <div className="flex flex-row justify-between">
              <span>Angebotsnr.:</span>
              <span>
                {bill.billPrefix}-{bill.billNumber}
              </span>
            </div>
            <div className="flex flex-row justify-between">
              <span>Datum:</span>
              <span>
                {bill.date ? dayjs(bill.date).format("DD.MM.YYYY") : ""}
              </span>
            </div>
            <div className="flex flex-row justify-between">
              <span>Status:</span>
              <span>
                {!bill.isCreated && (
                  <>
                    <Tooltip title="Entwurf">
                      <PendingActionsIcon style={{ color: "#5e5e5eee" }} />
                    </Tooltip>
                    Entwurf
                  </>
                )}
                {bill.isCreated && (
                  <>
                    <Tooltip title={bill.isPaid ? "Bezahlt" : "Offen"}>
                      <Paid style={{ color: "#105a37" }} />
                    </Tooltip>
                    {bill.isPaid ? "Bezahlt" : "Offen"}
                  </>
                )}
              </span>
            </div>
            <div className="flex flex-row justify-between">
              <span>Betrag:</span>
              <span>{bill?.netto?.toFixed(2).replace(".", ",")} €</span>
            </div>
          </div>
          <div className="flex flex-col w-[10%] mr-3">
            <MoreOptionsButton options={options} />
          </div>
        </div>
      )}
    </>
  );
};

export default OfferRow;
